import * as React from 'react';
import { cn } from '@/util/cn';
import { type LucideIcon } from 'lucide-react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: LucideIcon;
  rightIcon?: LucideIcon;
  wrapperClassName?: React.HTMLAttributes<HTMLInputElement>['className'];
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type, leftIcon: LeftIcon, rightIcon: RightIcon, wrapperClassName, ...props },
    ref
  ) => {
    return (
      <div className={cn('$tw-relative $tw-w-full', wrapperClassName)}>
        {LeftIcon && (
          <LeftIcon className="$tw-absolute $tw-left-3 $tw-top-1/2 $tw-size-5 -$tw-translate-y-1/2 $tw-transform" />
        )}

        <input
          type={type}
          className={cn(
            '$tw-flex $tw-h-10 $tw-w-full $tw-rounded-md $tw-border $tw-border-border/40 $tw-bg-transparent $tw-px-3 $tw-py-2 $tw-text-base $tw-font-normal $tw-text-foreground $tw-ring-offset-background file:$tw-border-0 file:$tw-bg-transparent file:$tw-text-sm file:$tw-font-medium file:$tw-text-foreground placeholder:$tw-text-muted-foreground hover:$tw-border-border/60 disabled:$tw-cursor-not-allowed disabled:$tw-opacity-50',
            className,
            LeftIcon && '$tw-pl-10',
            RightIcon && '$tw-pr-10'
          )}
          ref={ref}
          {...props}
        />

        {RightIcon && (
          <RightIcon className="$tw-absolute $tw-right-3 $tw-top-1/2 $tw-size-5 -$tw-translate-y-1/2 $tw-transform" />
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
